import { CmsActivatedRouteSnapshot, CmsService, ProtectedRoutesGuard, RoutingConfigService, RoutingService } from '@spartacus/core';
import { CanActivate, RedirectCommand, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { CmsPageGuard, CmsPageGuardService } from '@spartacus/storefront';
import { Observable, of, switchMap } from 'rxjs';
import { Injectable } from '@angular/core';

import { UrlMappingService } from '../services/url-mapping.service';
import { BaseStoreService } from '../services';
import { HobMapper } from '../mappers';

@Injectable({
  providedIn: 'root'
})
export class CustomCmsPageGuard extends CmsPageGuard implements CanActivate {
  isHob = false;
  constructor(
    protected routingService: RoutingService,
    protected cmsService: CmsService,
    protected protectedRoutesGuard: ProtectedRoutesGuard,
    protected service: CmsPageGuardService,
    protected routingConfig: RoutingConfigService,
    protected urlMappingService: UrlMappingService,
    protected router: Router,
    protected baseStoreService: BaseStoreService,
    private readonly hobMapper: HobMapper

  ) {
    super(routingService, cmsService, protectedRoutesGuard, service, routingConfig);
  }

  canActivate(route: CmsActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree | RedirectCommand> {
    const url = '/' + route.url.map((segment) => segment.path).join('/');
    const brands = this.baseStoreService.baseStore.houseOfBrandConfig?.brand?.map((brand) => this.hobMapper.toBrandEnum(brand.id)) ?? [];

    return this.urlMappingService.getUrlMappingByTranslation(url, brands).pipe(
      switchMap((urlMapping) => {
        if (urlMapping && urlMapping.code !== urlMapping.value) {
          const newUrl = decodeURIComponent(state.url).replace(urlMapping.value, urlMapping.code);
          return of(this.router.parseUrl(newUrl));
        } else {
          return super.canActivate(route, state);
        }
      })
    );
  }
}
